import React, { useEffect, useRef, useState } from 'react';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import gsap from 'gsap';

export const GameActivityThree = ({ data = { options: [] }, actionGameQuestion = () => { } }) => {
	const [selectAnswer, setSelectAnswer] = useState(-1);
	const [statusResponse, setStatusResponse] = useState(0);
	const [showResultImage, setShowResultImage] = useState(false);
	const [lastSelected, setLastSelected] = useState(-1);

	const handleSelectQuestion = (id) => {
		if (selectAnswer === id) return;

		ObserverEmitter.emit(EVENTS.activeButtonValidate, true)
		setSelectAnswer(id);
		setLastSelected(id);

		const selectedOption = data.options.find((opt) => opt.id === id);
		if (!selectedOption) return;

		setShowResultImage(false);
		setStatusResponse(selectedOption.isCorrect ? 1 : 2);
	};

	const handleValidation = () => {
		if (!selectAnswer) return;

		setTimeout(() => {
			setStatusResponse(0);
		}, 1000);
		setTimeout(() => {
			actionGameQuestion(statusResponse);
		}, 1000);
		setShowResultImage(true);
		setSelectAnswer(-1);
		ObserverEmitter.emit(EVENTS.activeButtonValidate, false)

	};

	return (
		<div className='fixed z-20 w-full h-full bottom-0 animate__animated  animate__fadeIn flex items-center justify-end'>
			<div className="h-full w-[304px] md:w-[480px] px-6 py-5 md:py-10 gradiantBlueClient flex flex-col justify-between items-center">
				<div className="w-full bg-red_primary rounded-[8px] md:rounded-[16px] flex justify-center items-stretch py-1 md:py-4 px-4">
					<p className="text-white text-[14px] md:text-[20px] font-bold">Selecciona la opción faltante.</p>
				</div>
				<div className='grid grid-cols-2 grid-rows-2 justify-center items-center gap-4 md:gap-9'>
					{data.options.map((question) => {
						return (
							<OptionsQuestion
								key={question.id}
								isSelected={selectAnswer === question.id}
								isLastSelected={lastSelected === question.id}
								handleSelect={handleSelectQuestion}
								showResult={showResultImage && statusResponse}
								{...question}
							/>
						);
					})}
				</div>
				<ButtonValidate
					name='Validar respuesta'
					disabled={!selectAnswer}
					onClick={handleValidation}
				/>
			</div>
		</div>
	);
};

const OptionsQuestion = ({ id, imgNeutral, imgSelected, imgResult, isSelected, isLastSelected, handleSelect, showResult }) => {
	const imageUrl = showResult && isLastSelected ? imgResult : isSelected ? imgSelected : imgNeutral;

	return (
		<figure className='w-[105px] h-[105px] md:w-[132px] md:h-[132px]' onClick={() => handleSelect(id)}>
			<img src={imageUrl} alt={`option${id}`} className="w-full h-full" />
		</figure>
	);
};

let checkoutAnimation = false
const ButtonValidate = ({ name = "Continuar", disabled = true, onClick }) => {
	const handleClick = () => {
		onClick();
	};
	const animationRef = useRef(null);
	const [activateButtonAnimation, setActivateButtonAnimation] = useState(false);

	ObserverEmitter.on(EVENTS.activeButtonValidate, (activate = false) => {
		// console.log(activate);
		setActivateButtonAnimation(activate)
	})
	useEffect(() => {
		if (!activateButtonAnimation) {
			// console.log("stop");
			stopAnimation()
			return
		}
		// console.log("activate");
		if (checkoutAnimation) {
			return
		}
		gsapAnimation()
	}, [activateButtonAnimation])

	const gsapAnimation = () => {
		checkoutAnimation = true
		animationRef.current = gsap.to(`#ButtonValidate`, {
			duration: 0.5,
			backgroundColor: "#FFC427",
			repeat: -1,
			yoyo: true,
		});
	};

	const stopAnimation = () => {
		checkoutAnimation = false
		gsap.set(`#ButtonValidate`, {
			backgroundColor: "#9A9A9A",
		});
		if (animationRef.current) {
			animationRef.current.kill();
			animationRef.current = null;
		}
	};

	return (
		<button
			id="ButtonValidate"
			onClick={() => {
				ObserverEmitter.emit(
					EVENTS.audiosEvents.createAudioActionButton,
					audiosAssets.barraNavegacion.completeNavigation
				);
				if (!activateButtonAnimation) {
					return;
				}
				handleClick()
			}}
			disabled={disabled}
			className={`boxShadowButtons w-full text-white text-[12px] md:text-xl font-semibold rounded-lg py-2 ${disabled ? "bg-[#9A9A9A]" : "bg-[#FFC427]"}`}
		>
			{name}
		</button>
	);
};

export default GameActivityThree;
